export default __webpack_public_path__ + "static/workplace-challenges-header-927c740f52c6f65f7393c0c163b296c2.png";